/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Category_DescriptionInputs */

const vi_expense_category_description = /** @type {(inputs: Expense_Category_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả`)
};

/**

* @param {Expense_Category_DescriptionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_category_description = /** @type {((inputs?: Expense_Category_DescriptionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Category_DescriptionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_category_description(inputs)
});